import { useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../pagination/Pagination4';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const StateWiseCommission = ({ month, year, allotMonth, allotYear, commId, distCode, bankType, reportTitle }) => {

  const [apiData, setApiData] = useState([]);
  const [commissionData, setCommissionData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');


  //  useEffect(() => {
  //   const fetCommissionCost = async () => {
  //     try{
  //       setLoading(true); 
  //       const commissioncostresponse = await fetch(`${process.env.REACT_APP_URL}/api/commission/commission-cost`);

  //        if(!commissioncostresponse.ok){
  //         throw new Error('Failed to fetch State commission data');
  //        }

  //       const data = await commissioncostresponse.json();
  //       setCommissionData(data);
  //     }
  //     catch(error){
  //        console.error('Fetch Error:', error);
  //        setError(error); 
  //     }
  //     finally{
  //       setLoading(false); 
  //     }
  //   }

  //  fetCommissionCost();
  //  },[]);


  //  useEffect(() => {
  //   const fetchStateCommissionData = async () => {
  //       try {
  //           setLoading(true); 
  //           const queryParams = new URLSearchParams({
  //             month,
  //             year,
  //             commId,
  //             allotMonth,
  //             allotYear,
  //             distCode,
  //             bankType              
  //           });

  //           const response = await fetch(
  //             `${process.env.REACT_APP_URL}/api/commission/fpsStateDetails?${queryParams}`
  //           );

  //           if (!response.ok) {
  //             throw new Error('Failed to fetch State commission data');
  //           }    
  //           const data = await response.json();
  //           setApiData(data);
  //         } catch (error) {
  //           console.error('Fetch Error:', error);
  //           setError(error); 
  //         } finally {
  //           setLoading(false); 
  //         }
  //   }
  //  fetchStateCommissionData();
  //  },[month, year, allotMonth, allotYear, commId, distCode, bankType]);

  useEffect(() => {

    const fetchData = async () => {

      try {
        setLoading(true);

        const queryParams = new URLSearchParams({
          month,
          year,
          commId,
          allotMonth,
          allotYear,
          distCode,
          bankType
        });

        const [commissionRes, stateRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_URL}/api/commission/commission-cost`),
          fetch(`${process.env.REACT_APP_URL}/api/commission/fpsStateDetails?${queryParams}`)
        ]);

        if (!commissionRes.ok || !stateRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const [commissionDataRes, stateDataRes] = await Promise.all([
          commissionRes.json(),
          stateRes.json()
        ]);

        setCommissionData(commissionDataRes);
        setApiData(stateDataRes);

      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error);
      } finally {
        setLoading(false);
      }

    };

    fetchData();

  }, [month, year, allotMonth, allotYear, commId, distCode, bankType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? apiData.length : parseInt(value, 10));
    setPage(0);
  };

  const filteredData = apiData.filter(item => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return Object.values(item).some(value => value && value.toString().toLowerCase().includes(query));
  });

  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (error) {
    return <div className="mainhead" align="center">Internal error</div>;
  }

  // if (apiData.length === 0) {
  //   return <div className="mainhead" align="center">No data found</div>;
  // }

  if (!loading && apiData.length === 0) {
    return (
      <div className="mainhead" align="center">
        No data found
      </div>
    );
  }

  const totals = filteredData.reduce(
    (acc, item) => {
      acc.nfsaShopTotalQty += Number(item.nfsaShopTotalQty) || 0;
      acc.nfsaStateAmount += Number(item.nfsaStateAmount) || 0;
      acc.stateShopTotalQty += Number(item.stateShopTotalQty) || 0;
      acc.nfsaExtraQty += Number(item.nfsaExtraQty) || 0;
      acc.totalStateQty += Number(item.totalStateQty) || 0;
      acc.stateAmount += Number(item.stateAmount) || 0;
      acc.totalAmount += Number(item.totalAmount) || 0;
      acc.tds += Number(item.tds) || 0;
      acc.ptax += Number(item.ptax) || 0;
      acc.finalCommission += Number(item.finalCommission) || 0;
      acc.count += 1;
      return acc;
    },
    {
      nfsaShopTotalQty: 0,
      nfsaStateAmount: 0,
      stateShopTotalQty: 0,
      nfsaExtraQty: 0,
      totalStateQty: 0,
      stateAmount: 0,
      totalAmount: 0,
      tdsPer: 0,
      tds: 0,
      ptax: 0,
      finalCommission: 0,
      count: 0,
    }
  );


  const handleDownloadExcel = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('State Commission');

    const totalColumns = 21;

    // Add the report title row with colspan (merge cells)
    worksheet.mergeCells(1, 1, 1, totalColumns); // Merge row 1, cols 1 to 21
    const titleCell = worksheet.getCell('A1');
    titleCell.value = reportTitle;
    titleCell.font = { size: 12, bold: true };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };


    // Define header row
    const headers = [
      "S.No",
      "District",
      "Office / Mandal",
      "Shop No.",
      "FPS Dealer Name",
      "Bank Name",
      "Branch Name",
      "IFSC Code",
      "PAN No",
      "Account No",
      "NFSA Quantity (in Kg) (A)",
      `Amount Payable Towards Commission (Rs ${commissionData.nfsaStateCost || 0} /kg) (B=A*${commissionData.nfsaStateCost || 0})`,
      "State Quantity (in Kg) (C)",
      "NFSA Extra Quantity (in Kg) (D)",
      "Total Quantity (in Kg) (E=C+D)",
      `Total State Amount (F=E*${commissionData.stateCost || 0})`,
      "Total (B+F)",
      "TDS (%)",
      "TDS (G)",
      "Professional Tax  (H)",
      `Total Commission (Rs ${commissionData.stateCost || 0} /kg) (B+F-G-H)`
    ];

    worksheet.addRow(headers);

    // Apply styles to header (row 2)
    const headerRow = worksheet.getRow(2);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center' };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Add data rows starting from row 3
    data.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.distNameEn,
        item.afsoNameEn,
        item.fpsId,
        item.dealerName,
        item.bankName,
        item.branchName,
        item.ifscCode,
        item.panNo,
        item.acNo,
        parseFloat(item.nfsaShopTotalQty.toFixed(3)),
        parseFloat(item.nfsaStateAmount.toFixed(2)),
        parseFloat(item.stateShopTotalQty.toFixed(3)),
        parseFloat(item.nfsaExtraQty.toFixed(3)),
        parseFloat(item.totalStateQty.toFixed(3)),
        parseFloat(item.stateAmount.toFixed(2)),
        parseFloat(item.totalAmount.toFixed(2)),
        item.tdsPer,
        parseFloat(item.tds.toFixed(2)),
        item.ptax,
        parseFloat(item.finalCommission.toFixed(2))
      ]);

      // Left align first 10 columns
      for (let i = 1; i <= 10; i++) {
        row.getCell(i).alignment = { horizontal: "left" };
      }
      // Right align columns 11 to 19
      for (let i = 11; i <= 19; i++) {
        row.getCell(i).alignment = { horizontal: "right" };
      }
    });

    // Calculate totals manually first
    const totals = data.reduce(
      (acc, item) => {
        acc.nfsaShopTotalQty += Number(item.nfsaShopTotalQty) || 0;
        acc.nfsaStateAmount += Number(item.nfsaStateAmount) || 0;
        acc.stateShopTotalQty += Number(item.stateShopTotalQty) || 0;
        acc.nfsaExtraQty += Number(item.nfsaExtraQty) || 0;
        acc.totalStateQty += Number(item.totalStateQty) || 0;
        acc.stateAmount += Number(item.stateAmount) || 0;
        acc.totalAmount += Number(item.totalAmount) || 0;
        acc.tds += Number(item.tds) || 0;
        acc.tdsPer += Number(item.tdsPer) || 0;
        acc.ptax += Number(item.ptax) || 0;
        acc.finalCommission += Number(item.finalCommission) || 0;
        acc.count += 1;
        return acc;
      },
      {
        nfsaShopTotalQty: 0,
        nfsaStateAmount: 0,
        stateShopTotalQty: 0,
        nfsaExtraQty: 0,
        totalStateQty: 0,
        stateAmount: 0,
        totalAmount: 0,
        tds: 0,
        tdsPer: 0,
        ptax: 0,
        finalCommission: 0,
        count: 0,
      }
    );


    // Add total row below the last data row
    const totalRowNumber = worksheet.lastRow.number + 1;

    // Merge first 10 columns for 'Total' label
    worksheet.mergeCells(totalRowNumber, 1, totalRowNumber, 10);

    // Add total values row
    const totalRow = worksheet.addRow([
      '', // This will be merged across 10 cells
      '', '', '', '', '', '', '', '', 'Total',
      totals.nfsaShopTotalQty.toFixed(3),
      totals.nfsaStateAmount.toFixed(2),
      totals.stateShopTotalQty.toFixed(3),
      totals.nfsaExtraQty.toFixed(3),
      totals.totalStateQty.toFixed(3),
      totals.stateAmount.toFixed(2),
      totals.totalAmount.toFixed(2),
      '', // TDS % (no total)
      totals.tds.toFixed(2),
      totals.ptax.toFixed(2),
      totals.finalCommission.toFixed(2)
    ]);

    // Style total row
    totalRow.font = { bold: true };
    totalRow.alignment = { horizontal: 'right' };
    totalRow.getCell(1).alignment = { horizontal: 'left' };

    totalRow.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'double' },
        right: { style: 'thin' }
      };
      // Keep alignment consistent for merged cells
      if (colNumber <= 10) {
        cell.alignment = { horizontal: 'left' };
      }
    });

    // Auto width adjustment for columns
    worksheet.columns.forEach((col, index) => {
      let maxLength = 10; // minimum width to avoid super narrow columns
      const headerText = headers[index] || '';
      if (headerText.length > maxLength) maxLength = headerText.length;

      col.eachCell({ includeEmpty: true }, (cell) => {
        let cellValue = cell.value;

        // If cell value is an object (like a Date), convert to string
        if (cellValue && typeof cellValue === 'object') {
          if (cellValue.richText) {
            cellValue = cellValue.richText.map(rt => rt.text).join('');
          } else if (cellValue.text) {
            cellValue = cellValue.text;
          } else if (cellValue.result) {
            cellValue = cellValue.result.toString();
          } else {
            cellValue = cellValue.toString();
          }
        } else if (cellValue === null || cellValue === undefined) {
          cellValue = '';
        } else {
          cellValue = cellValue.toString();
        }

        if (cellValue.length > maxLength) {
          maxLength = cellValue.length;
        }
      });

      // Optionally limit max width so columns don't get huge
      const maxAllowedWidth = 50;
      col.width = maxLength > maxAllowedWidth ? maxAllowedWidth : maxLength + 2;
    });

    // Save and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `State_Wise_Commission.xlsx`);


  };

  return (
    <div style={{ justifyContent: 'center', marginBottom: '10px' }}>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '90%', margin: '0 auto 20px auto' }}>

        {<div style={{ width: '150px' }}></div>}

        <div style={{ align: 'center' }}>

          <PaginationTable
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Search "
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ padding: '8px', width: '200px' }}
          />
        </div>
      </div>

      <table width="90%" border="1" cellPadding="5" cellSpacing="0" >
        <thead style={{ position: 'sticky', top: 0 }}>

          <tr className="tableheader"><th colSpan={21}>{reportTitle}</th></tr>

          <tr className="tableheader">
            <th>S.No</th>
            <th>District</th>
            <th>Office / Mandal</th>
            <th>Shop No.</th>
            <th>FPS Dealer Name</th>
            <th>Bank Name</th>
            <th>Branch Name</th>
            <th>IFSC Code</th>
            <th>PAN No</th>
            <th>Account No</th>
            <th>NFSA Quantity (in Kg) <br /><font style={{ color: "orange" }}>(A)</font></th>
            <th>Amount Payable Towards Commission (Rs {commissionData.nfsaStateCost} /kg) <br /><font style={{ color: "orange" }}>(B=A*{commissionData.nfsaStateCost})</font></th>
            <th>State Quantity (in Kg)<br /><font style={{ color: "orange" }}>(C)</font></th>
            <th>NFSA Extra Quantity (in Kg)<br /><font style={{ color: "orange" }}>(D)</font></th>
            <th>Total Quantity (in Kg)<br /><font style={{ color: "orange" }}>(E=C+D)</font></th>
            <th>Total<br />State<br />Amount <br /><font style={{ color: "orange" }}>(F=E*{commissionData.stateCost})</font></th>
            <th>Total<br />(B+F)</th>
            <th>TDS <br /><font style={{ color: "orange" }}>(%)</font> </th>
            <th>TDS <font style={{ color: "orange" }}>(G)</font></th>
            <th>Professional Tax <br /> <font style={{ color: "orange" }}>(H)</font></th>
            <th>Total Commission (Rs {commissionData.stateCost} /kg) <br /><font style={{ color: "orange" }}>(B+F-G-H)</font></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={index}>
              <td>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td>
              <td>{item.distNameEn}</td>
              <td>{item.afsoNameEn}</td>
              <td>{item.fpsId}</td>
              <td>{item.dealerName}</td>
              <td>{item.bankName}</td>
              <td>{item.branchName}</td>
              <td>{item.ifscCode}</td>
              <td>{item.panNo}</td>
              <td>{item.acNo}</td>
              <td style={{ textAlign: 'right' }}>{item.nfsaShopTotalQty.toFixed(3)}</td>
              <td style={{ textAlign: 'right' }}>{item.nfsaStateAmount.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.stateShopTotalQty.toFixed(3)}</td>
              <td style={{ textAlign: 'right' }}>{item.nfsaExtraQty.toFixed(3)}</td>
              <td style={{ textAlign: 'right' }}>{item.totalStateQty.toFixed(3)}</td>
              <td style={{ textAlign: 'right' }}>{item.stateAmount.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.totalAmount.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.tdsPer.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.tds.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.ptax.toFixed(2)}</td>
              <td style={{ textAlign: 'right' }}>{item.finalCommission.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ fontWeight: 'bold' }} className="tableheader">
            <td colSpan={10} style={{ textAlign: 'right' }}>Total</td>
            <td style={{ textAlign: 'right' }}>{totals.nfsaShopTotalQty.toFixed(3)}</td>
            <td style={{ textAlign: 'right' }}>{totals.nfsaStateAmount.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.stateShopTotalQty.toFixed(3)}</td>
            <td style={{ textAlign: 'right' }}>{totals.nfsaExtraQty.toFixed(3)}</td>
            <td style={{ textAlign: 'right' }}>{totals.totalStateQty.toFixed(3)}</td>
            <td style={{ textAlign: 'right' }}>{totals.stateAmount.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.totalAmount.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}></td>
            <td style={{ textAlign: 'right' }}>{totals.tds.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.ptax.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.finalCommission.toFixed(2)}</td>
          </tr>
          <tr >
            <td colSpan={21} style={{ textAlign: 'right' }}>
              Data Time:  <font style={{ color: 'red' }}>
                {paginatedData[0]?.dataTime?.substring(0, 19)?.replace('T', ' ') || '--'}
              </font>
            </td>
          </tr>
        </tfoot>
      </table>
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button onClick={() => handleDownloadExcel(apiData)} className="button button2">Download Excel</button>
      </div>

    </div>

  );





}

export default StateWiseCommission;
